import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';

import { estiloBotao } from '@/ui/primitives/estilos';
import { type EmpresaDetalhe } from '@fiscoai/contracts';

export function AvisoCertificado({
  empresa,
  motivo,
  podeEnviar,
}: {
  empresa: EmpresaDetalhe;
  motivo: string;
  /** Só quem gerencia o certificado ganha o atalho; os demais leem a quem pedir. */
  podeEnviar: boolean;
}) {
  return (
    <div
      role="status"
      aria-label="Certificado"
      className="flex flex-wrap items-center justify-between gap-3 rounded-cartao border border-alerta/40 bg-alerta-suave px-4 py-3"
    >
      <p className="flex items-start gap-2 text-sm">
        <ShieldAlert className="mt-0.5 size-4 shrink-0 text-alerta" aria-hidden />
        {motivo}
      </p>
      {podeEnviar ? (
        <Link
          to={`/empresas/${empresa.id}?aba=certificado`}
          className={estiloBotao({ tamanho: 'sm' })}
        >
          Enviar certificado
        </Link>
      ) : (
        <span className="text-xs text-texto-suave">
          Peça o envio a quem gerencia o certificado.
        </span>
      )}
    </div>
  );
}
